// Cooling-Off Period Calculator
// UK Consumer Rights Act 2015 requires 14 days minimum
// HiBFF offers 90 days (6x legal minimum)

export const calculateCoolingOff = (subscribedDate) => {
  const today = new Date();
  const subscribed = new Date(subscribedDate);
  const endsDate = new Date(subscribed);
  endsDate.setDate(endsDate.getDate() + 90);

  const daysElapsed = Math.floor((today - subscribed) / (1000 * 60 * 60 * 24));
  const daysRemaining = 90 - daysElapsed;
  const percentElapsed = (daysElapsed / 90) * 100;

  return {
    endsDate: endsDate.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' }),
    daysRemaining: Math.max(0, daysRemaining),
    percentElapsed: Math.min(100, Math.round(percentElapsed)),
    refundEligible: daysRemaining > 0
  };
};

export const getProgressBarColor = (percentElapsed) => {
  if (percentElapsed <= 33) return 'bg-green-500'; // 0-30 days (67-100% remaining)
  if (percentElapsed <= 66) return 'bg-yellow-500'; // 31-60 days (34-66% remaining)
  if (percentElapsed < 100) return 'bg-orange-500'; // 61-90 days (1-33% remaining)
  return 'bg-gray-400'; // 90+ days (cooling-off expired)
};

export const calculateTotalPaid = (subscribedDate, monthlyPrice) => {
  const today = new Date();
  const subscribed = new Date(subscribedDate);
  const monthsElapsed = Math.floor((today - subscribed) / (1000 * 60 * 60 * 24 * 30));
  return (monthsElapsed + 1) * monthlyPrice; // +1 for current month
};
